import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import { isAd, convertRouteNameToTitle, isMobile } from '../util'
import { MOBILE_URL } from '../const'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/course',
    name: 'Course',
    component: () => {
      if (isAd()) {
        return import(
          /* webpackChunkName: "course" */ '../views/CourseAd/index.vue'
        )
      } else {
        return import(
          /* webpackChunkName: "course" */ '../views/Course/index.vue'
        )
      }
    },
  },
  {
    path: '/download',
    name: 'Download',
    component: () =>
      import(/* webpackChunkName: "download" */ '../views/Download/index.vue'),
  },
]

const router = new VueRouter({
  //mode: isAd() ? 'history' : '',
  routes,
})

//  路由拦截，如果是手机端则重定向
router.beforeEach((to, from, next) => {
  if (isMobile()) {
    location.replace(MOBILE_URL)
  } else {
    next()
  }
})

// 路由切换后钩子
router.afterEach(async (route) => {
  if (isAd()) {
    // 若果推广页，在页面访问时，上报神策
    const { default: sensors } = await import('sa-sdk-javascript')
    sensors.track('$pageview', {
      $title: convertRouteNameToTitle(route.name),
    })
  }
  window.scrollTo({ top: 0, left: 0 })
})

export default router
